<template>
  <div class="mail_game_container">
    <div class="mail_game_top">
      <div class="mail_game_top_img">
        <img :src="mailTopbgSrc" width="100%" height="100%" alt="" />
      </div>
      <div class="mail_game_top_subtitle">EPISODE 3</div>
      <div class="mail_game_top_button_box" v-if="alreadyApply == false">
        <button class="mail_top_button" v-on:click="applyJoinGameEvent">
          COUNT ME IN
        </button>
      </div>
      <div class="mail_game_top_button_box" v-else >
        <div class="mail_game_center_status_title">
            YOU'RE IN
        </div>
      </div>
    </div>
    <div class="mail_game_center_1">
      <div class="mail_game_top_img">
        <img :src="mailCenterbgSrc" width="100%" height="100%" alt="" />
      </div>
      <div class="mail_game_center_slot">GAME SLOT: <br/>{{gameSlot}}</div>
      <div v-if="alreadyApply" class="mail_game_center_status">
        <div class="mail_game_center_status_title">
            YOU'RE IN
        </div>
        <div class="mail_game_center_status_subtitle">
            if you really have to leave the game, <br>please confirm your choice on your freebeat bike.
        </div>
      </div>
      <div v-else class="mail_game_center_status">
        <div class="mail_game_center_button">
            <button class="mail_top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
            COUNT ME IN
            </button>
        </div>
        <div class="mail_game_center_right_txt">
            Registration is open until {{deadline}}
        </div>
      </div>
    </div>
    <div class="mail_game_center_2">
      <div class="mail_game_top_img">
        <img :src="mailBottombgSrc" width="100%" height="100%" alt="" />
      </div>
      <div class="mail_game_center_slot_2">This week’s prizes are.....</div>
      <div v-if="alreadyApply" class="mail_game_center_status_2">
        <div class="mail_game_center_status_title">
            YOU'RE IN
        </div>
        <div class="mail_game_center_status_subtitle">
            if you really have to leave the game, <br>please confirm your choice on your freebeat bike.
        </div>
      </div>
      <div v-else class="mail_game_center_status_2">
        <div class="mail_game_center_button_2">
            <button class="mail_top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
            COUNT ME IN
            </button>
        </div>
        <div class="mail_game_center_right_txt_2">
              Registration is open until {{deadline}}
        </div>  
      </div>
    </div>
    <div class="mail_game_bottom">
      <div class="mail_game_top_img">
        <img :src="mailFooterbgSrc" width="100%" height="100%" alt="" />
      </div>
    </div>
    <div :class="dialogVisible ? 'm_float_bg_box_color':'m_float_bg_box'">
      <div :class="dialogVisible ? 'm_float_box' : 'm_show-float'" :style="floatBackground">
        <div class="m_float_title">YOU ARE IN! </div>
        <div class="m_float_content">see you on the leaderboard!</div>
        <button class="m_float_button" v-on:click="sureEvent">
          SURE
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../api/http';
  import {
    Message
  } from 'element-ui';

  export default {
    name: 'CyclingMobileGame',
    data() {
      return {
        isMobile: false,
        mailTopbgSrc: require('../assets/mail-game-1.png'),
        mailCenterbgSrc: require('../assets/mail-game-2.png'),
        mailBottombgSrc: require('../assets/mail-game-3.png'),
        mailFooterbgSrc: require('../assets/mail-game-4.png'),
        floatBackground: {
          backgroundImage: 'url(' + require('../assets/float-bg.png') + ')'
        },
        dialogVisible: false,
        gameSlot: '',
        deadline: '',
        alreadyApply: false,
        stopApply: true,
        isDisable: false,
      }
    },
    
    methods: {
      getGameInfoEvent()  {
          let query = this.$route.query;
          let mail = query.email;
          if (mail == 'null' || mail == '' || mail == 'undefined') {
              Message.error('server error');
              return
          }
          let params = {
              'email': mail
          }
          api.get('client-api/v1/game/info', params).then((res) => {
              if (res.data.code == 200) {
                  let data = res.data.data;
                  this.gameSlot = data.gameSlot;
                  this.deadline = data.deadline;
                  this.alreadyApply = data.alreadyApply;
                  this.stopApply = data.stopApply;
              } else {
                  Message.error(res.data.msg);
                  return
              }
          }).catch (error => {
              Message.error(error);
          })
      },
      applyJoinGameEvent() {
          this.isDisable = true;
          if(this.stopApply) {
              this.$router.push('/pc-rttt-4-rank');
              return;
          }
          let query = this.$route.query;
          let mail = query.email;
          if (mail == 'null' || mail == '' || mail == 'undefined') {
              Message.error('server error');
              return
          }
          let params = {
              'email': mail
          }
          api.post('client-api/v1/game/apply', params).then((res) => {
              this.isDisable = false;
              if (res.data.code == 200) {
                  this.dialogVisible = true;
              } else {
                  Message.error(res.data.msg);
                  return
              }
          }).catch (error => {
              this.isDisable = false;
              Message.error(error);
          })
      },
      exitGameEvent() {
          let query = this.$route.query;
          let mail = query.email;
          if (mail == 'null' || mail == '' || mail == 'undefined') {
              Message.error('server error');
              return
          }
          let params = {
              'email': mail
          }
          api.post('client-api/v1/game/apply/cancel', params).then((res) => {
              if (res.data.code == 200) {
                  this.alreadyApply = false;
              } else {
                  Message.error(res.data.msg);
                  return
              }
          }).catch (error => {
              Message.error(error);
          })
      },
      sureEvent() {
          this.dialogVisible = false;
          this.alreadyApply = true;
      }
    },
    mounted() {
      let clientWidth = document.documentElement.clientWidth || document.body.clientHeight;
      if (clientWidth < 768) { //当屏幕小于768时，设置Vuex里的数据为true
        this.isMobile = true;
      } else { //反之，设置Vuex里的数据为false
        this.isMobile = false;
      }
      this.getGameInfoEvent();
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  @import '../fonts/font.css';

  .mail_game_container {
    display: flex;
    flex-direction: column;
    min-width: 320px;
    max-width: 640px;
    margin: 0 auto;
  }

  .mail_game_top {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    font-size: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .mail_game_top_img {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mail_game_top_subtitle {
    position: absolute;
    bottom: 40%;
    font-size: 18px;
    font-family: Montserrat-Medium;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.8);
  }
  .mail_game_top_button_box {
    position: absolute;
    bottom: 30%;
  }

  .mail_top_button {
    width: 190px;
    height: 40px;
    font-size: 20px;
    border: 0;
    margin: 0;
    font-size: 15px;
    font-weight: bold;
    color: #ffffff;
    background: linear-gradient(135deg, #7D00FF 0%, #8F0AF5 49%, #FF5FA2 100%);
    box-shadow: 0 12px 16px 0 rgba(143, 10, 245, 0.35), 0 17px 50px 0 rgba(255, 95, 162, 0.35);
    font-family: Montserrat-Bold;
    cursor: pointer;
  }
  .mail_game_center_1 {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    font-size: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .mail_game_center_slot {
    width: 90%;
    position: absolute;
    top: 10%;
    text-align: left;
    font-family: Montserrat-Regular;
    font-weight: 400;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.8);
  }
  .mail_game_center_status {
    position: absolute;
    bottom: 5%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .mail_game_center_status_title {
    width: 100%;
    color: rgba(255, 255, 255, 0.9); 
    text-align: center;
    font-family: Montserrat-Bold;
    font-size: 24px;
    font-weight: bold;
  }
  .mail_game_center_status_subtitle {
    width: 100%;
    margin-top: 10px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 20px;
    font-size: 15px;
  }
  .mail_game_center_button {
    margin-top: 15px;
  }
  .mail_game_center_right_txt {
    margin-top: 18px;
    font-family: Montserrat-Regular;
    font-weight: 400;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.7);
  }

  .mail_game_center_2 {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    font-size: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .mail_game_center_status_2 {
    width: 100%;
    position: absolute;
    bottom: 2%;
  }
  .mail_game_center_slot_2 {
    width: 90%;
    position: absolute;
    top: 8.5%;
    text-align: left;
    font-family: Montserrat-Regular;
    font-weight: 400;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.8);
  }
  .mail_game_center_button_2 {
    margin-top: 15px;
  }
  .mail_game_center_right_txt_2 {
    margin-top: 18px;
    font-family: Montserrat-Regular;
    font-weight: 400;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.7);
  }
  
  .m_float_bg_box {
    display: none;
    position: absolute;
    width: 100%;
    height: 300%;
    left: 0;
    top: 0;
  }

  .m_float_bg_box_color {
    display: block;
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    width: 100%;
    height: 300%;
    left: 0;
    top: 0;
  }

  .m_float_box {
    display: block;
    width: 100%;
    height: 40%;
    position: fixed;
    left: 0;
    top: calc(15%);
  }

  .m_float_title {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    margin-top: 114px;
  }

  .m_float_content {
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 1px;
    color: #fff;
    margin-top: 24px;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .m_show-float {
    display: none;
  }

  .m_float_button {
    margin: 0 auto;
    width: 320px;
    height: 60px;
    background: linear-gradient(135deg, #7D00FF 0%, #8F0AF5 49%, #FF5FA2 100%);
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    margin-top: 37px;
    font-family: Montserrat-Bold;
    cursor: pointer;
    border: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/CyclingMobileGame.vue